import RepositoryFactory from "../../admin/apis/index";
const orderReturn = RepositoryFactory.ecomOrderReturn;

export default {
  addOrderReturn({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await orderReturn.addOrderReturn(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateOrderReturn({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await orderReturn.updateOrderReturn(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getOrderReturn({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await orderReturn.getOrderReturn(payload);

        commit("SET_ORDERRETURN", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
